<script>
import robertHenryImg from '@/assets/images/Robert HENRY.png';
import hongwenHuangImg from '@/assets/images/Hongwen HUANG.png';
import chentaoLinImg from '@/assets/images/Chentao Lin.png';
import mingPengImg from '@/assets/images/Ming Peng.png';
import wenquanWangImg from '@/assets/images/Wenquan Wang.png';
import youxiongQueImg from '@/assets/images/Youxiong Que.png';
import yunZhengImg from '@/assets/images/Yun Zheng.png';
import xiHuangImg from '@/assets/images/Xi Huang.png';
import supachaiImg from '@/assets/images/Supachai Vuttipongchaikij.png';
import piyaImg from '@/assets/images/Piya Kittipadakul.png';
import yinhuaChenImg from '@/assets/images/Yinhua Chen.png';
import zhiqiangXiaImg from '@/assets/images/Zhiqiang Xia.png';
import fuqiangWangImg from '@/assets/images/Fuqiang Wang.png';
import jinpengWanImg from '@/assets/images/Jinpeng WAN.jpg';
import peitaoLuImg from '@/assets/images/Peitao Lu.png';
import liyunYangImg from '@/assets/images/Liyun Yang.png';
import yuhuaChenImg from '@/assets/images/Yuhua Chenv.png';

export default {
  name: 'Speakers',
  data() {
    return {
      speakerBios: [
        {
          name: 'Robert HENRY',
          image: robertHenryImg,
          bio: 'Robert Henry is a distinguished professor at the University of Queensland, with expertise spanning plant genetics, agricultural biotechnology, and food science. He has been elected as an academician of the Australian Academy of Science and Engineering. His research focuses on leveraging genomic tools to enhance crop sustainability, improve food security, and advance natural resource management. Professor Robert Henry has long been at the forefront of plant genetics and crop improvement research. He has authored over 300 papers in leading journals like Nature Biotechnology and Theoretical and Applied Genetics and edited key books such as Genomics of Crop Wild Relatives. His work spans critical crops like rice and wheat, achieving breakthroughs in genome-wide association studies and gene editing for stress resistance. He has also led major projects funded by the Australian Research Council and other organizations. His work not only drives innovation in agricultural science but also supports practical applications for sustainable food production.'
        },
        {
          name: 'Hongwen HUANG',
          image: hongwenHuangImg,
          bio: 'Dr. Huang Hongwen is Professor at the Chinese Academy of Sciences (CAS) and Director of Lushan Botanical Garden. He is also the former director of South China Botanical Garden and Wuhan Botanical Garden, CAS. His career spans more than 40 years in the field of plant genetic resources and breeding. He is internationally renowned for his pioneering research on kiwifruit germplasm and breeding. Dr. Huang has developed and commercialized novel yellow-fleshed kiwifruit cultivars (Actinidia chinensis) that are now widely cultivated around the world. His recent research focuses on the ex situ flora of China to advance conservation science, as well as the exploration of wild plants for the development of new crops. Professor Huang has authored more than 400 papers, more than 50 books and holds more than 20 registered or patented cultivars.'
        },
        {
          name: 'Chentao Lin',
          image: chentaoLinImg,
          bio: 'Dr. Chentao Lin is Professor at Fujian Agriculture and Forestry University (FAFU) and Director of the Basic Forestry and Proteomics Research Center. Professor Lin is one of the discoverers of the plant blue-light receptor cryptochrome (CRY), who discovered that the blue light-absorbing chromophore of cryptochromes is flavin adenine dinucleotide (FAD) and that cryptochromes are major photoreceptors regulating photoperiodism of plants. Professor Lin has dedicated his research to the regulatory and signaling mechanisms of plant cryptochromes. His laboratory has uncovered light-dependent CRY oligomerization, CRY phosphorylation, and CRY ubiquitination, along with regulatory mechanisms of plant CRYs including CRY oligomerization suppressors (BICs), CRY kinases (PPKs), and CRY ubiquitin ligases (COP1 and LRBs). At FAFU, he continues to investigate molecular mechanisms of plant cryptochromes, especially how cryptochromes regulate transcription elongation to protect plants in high-light environments.'
        },
        {
          name: 'Ming Peng',
          image: mingPengImg,
          bio: 'Professor Ming Peng is director of the Academic Committee at the Institute of Tropical Biosciences & Biotechnology and executive deputy director at the Chinese Academy of Tropical Agricultural Sciences. He is also a senior expert connected to the central and Hainan governments, a national outstanding science and technology worker, chief scientist of the 973 Project, and a recipient of several awards. He led more than 20 projects, including national 973 and 863 projects, and published over 40 SCI journal papers and more than 120 papers in Chinese core journals. He has edited 7 books, secured a national invention patent, and trained more than 40 postdoctoral, doctoral, and masters students.'
        },
        {
          name: 'Wenquan Wang',
          image: wenquanWangImg,
          bio: 'Dr. Wenquan Wang is a senior scientist in genomics and molecular breeding for tropical crops such as cassava and tropical fruits. His research focuses on molecular regulation and signal transduction involved in efficient photosynthesis, sucrose transport from source to storage root sink, and starch accumulation in the sink. He has led major national projects, obtained patents, and published over 200 papers, including work in Nature Communications, Molecular Plant, NAR and Plant Biotechnology Journal. He is founding editor in chief of Tropical Plants.'
        },
        {
          name: 'Youxiong Que',
          image: youxiongQueImg,
          bio: 'Dr. Youxiong Que is Professor at the Institute of Tropical Bioscience and Biotechnology and director of the Sugarcane Research Center in CATAS. His interests focus on crop genetics and biotechnology, especially sugarcane biotechnology, including crop-pathogen interaction, gene mining, function identification, and molecular breeding. He has conducted several projects supported by major national and provincial programs, published more than 100 articles, and holds dozens of innovation patents.'
        },
        {
          name: 'Yun Zheng',
          image: yunZhengImg,
          bio: 'Yun Zheng is a professor of bioinformatics at Yunnan Agricultural University. He received his PhD in Computer Science from Nanyang Technological University, Singapore, and has worked at National University of Singapore and Washington University in St. Louis. His interests include computational methods for genomics, transcriptomics, machine learning, and related biological data analysis. He has published over 90 papers in journals such as Nature, Nucleic Acids Research, Advanced Science, and Plant Cell.'
        },
        {
          name: 'Xi Huang',
          image: xiHuangImg,
          bio: 'Xi Huang is a PhD, Professor and doctoral supervisor at Hainan University. He specializes in tropical crop diseases and control technologies. He has led national projects, published more than 40 SCI papers, and received multiple scientific awards in Hainan Province.'
        },
        {
          name: 'Supachai Vuttipongchaikij',
          image: supachaiImg,
          bio: 'Supachai Vuttipongchaikij is an associate professor in the Department of Genetics, Faculty of Science, Kasetsart University. He has more than 15 years of experience in plant molecular genetics and biotechnology, including plant cell wall biology, genetic engineering, and genome editing. His recent work focuses on CRISPR/Cas-based genome editing for crop improvement in Thailand, particularly cassava.'
        },
        {
          name: 'Piya Kittipadakul',
          image: piyaImg,
          bio: 'Professor Dr. Piya Kittipadakul is a plant breeder in the Department of Agronomy, Faculty of Agriculture, Kasetsart University, Thailand. He received his PhD in Plant Breeding and Plant Genetics from the University of Wisconsin-Madison, USA. His expertise includes plant breeding, quantitative genetics, experimental design, and molecular and statistical approaches in crop improvement. His recent work emphasizes developing cassava varieties resistant to Cassava Mosaic Disease (CMD) and improving yield and starch quality. He has led many national and international cassava projects and currently serves as President of the Plant Breeding and Multiplication Association of Thailand.'
        },
        {
          name: 'Yinhua Chen',
          image: yinhuaChenImg,
          bio: 'Professor Yinhua Chen is a professor and PhD supervisor at Hainan University and a position scientist of the National Cassava Industry Technology System in China. His research focuses on cassava-microbe interactions and disease prevention and control technologies. He has published more than 200 papers, authored 5 books, and obtained 30 authorized patents.'
        },
        {
          name: 'Zhiqiang Xia',
          image: zhiqiangXiaImg,
          bio: 'Dr. Zhiqiang Xia is Professor at Hainan University, specializing in genomic large language models, nucleic acid foundation models, bioinformatics, multi-omics, and high-throughput technology development. His team has completed multiple high-quality tropical crop genomes and developed plant genomic AI models and integrated bioinformatics systems. He has led or participated in many national projects, holds patents, and published in journals such as The Innovation, Molecular Plant, Plant Biotechnology Journal, and Nucleic Acids Research.'
        },
        {
          name: 'Fuqiang Wang',
          image: fuqiangWangImg,
          bio: 'Dr. Fuqiang Wang graduated from China Agricultural University in 2022 and is currently a Young Researcher at the Institute of Genetics and Developmental Biology, Chinese Academy of Sciences / Hainan Seed Industry Laboratory. His research focuses on Sesbania cannabina breeding, biological remediation of saline-alkali and acidic sulfate soils, and rhizosphere microbial resource discovery under abiotic stress conditions.'
        },
        {
          name: 'Jinpeng WAN',
          image: jinpengWanImg,
          bio: 'Dr. Jinpeng WAN is an Associate Professor at Xishuangbanna Tropical Botanical Garden, Chinese Academy of Sciences. His research focuses on crop science and plant nutrition, with emphasis on genetic and molecular dissection of agronomic traits in tropical rice germplasm, including yield, grain quality, and stress resistance. He has published SCI-indexed papers and received major youth talent recognitions.'
        },
        {
          name: 'Peitao Lu',
          image: peitaoLuImg,
          bio: 'Peitao Lu is a Professor at the Institute of Tropical Bioscience and Biotechnology, Chinese Academy of Tropical Agricultural Sciences, and Principal Investigator at the National Key Laboratory of Tropical Crop Breeding in China. His research focuses on formation and regulation of key traits in horticultural fruit crops such as banana. He has published over 50 papers in international journals including Nature Genetics, Nature Plants, Nature Communications and Plant Cell.'
        },
        {
          name: 'Liyun Yang',
          image: liyunYangImg,
          bio: 'Dr. Yang Liyun is currently a postdoctoral researcher at Hainan University, working under the co-supervision of Professor Chen Yinhua. Her research focuses on the molecular interplay between cassava and the bacterial pathogen Xanthomonas phaseoli pv. manihotis (Xpm). She specializes in uncovering the molecular mechanisms underlying cassava resistance to Xpm and the pathogenic strategies employed by Xpm within cassava. Dr. Yang has authored and co-authored more than ten peer-reviewed publications and has led or contributed to multiple projects funded by the National Natural Science Foundation of China and the Hainan Provincial Natural Science Foundation.'
        },
        {
          name: 'Yuhua Chen',
          image: yuhuaChenImg,
          bio: 'Yuhua Chen is a PhD student majoring in Crop Science at Hainan University. His research focuses on the fruit quality formation mechanism of abiu (Pouteria caimito). He previously served as project leader for the Hainan Provincial Graduate Innovation Research Project, conducting research on crop stress resistance mechanisms based on multi-omics integration.'
        }
      ]
    };
  }
};
</script>

<template>
  <div class="speakers-container">
    <div class="speakers">
      <div class="section-title">Brief Introduction of Speakers</div>
      <div v-for="speaker in speakerBios" :key="speaker.name" class="speaker-card">
        <img :src="speaker.image" :alt="speaker.name" class="speaker-avatar" />
        <div class="speaker-content">
          <h2>{{ speaker.name }}</h2>
          <p>{{ speaker.bio }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.speakers-container {
  width: 66%;
  margin: 50px auto 0;
  padding: 0;
}

.section-title {
  background-color: rgb(230, 184, 186);
  padding: 10px;
  font-size: 1.8em;
  font-weight: bold;
}

.speaker-card {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  padding: 14px 16px;
  margin-top: 12px;
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.speaker-avatar {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  object-fit: contain;
  background: #f6f8fb;
  border: 1px solid #e4eaf1;
  flex-shrink: 0;
}

.speaker-content {
  min-width: 0;
}

.speaker-card h2 {
  margin: 0 0 8px;
  font-size: 1.25em;
}

.speaker-card p {
  margin: 0;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .speaker-card {
    flex-direction: column;
  }

  .speaker-avatar {
    width: 100%;
    max-width: 260px;
    height: auto;
    aspect-ratio: 1 / 1;
  }
}
</style>
